import React, { useEffect, useState } from "react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  AddButton,
  SearchToggleButton,
} from "../../utils/commonComponent/Custom/Button";
import { submitSiteDelete } from "./../../utils/commonComponent/delete";
import { fetchQuery } from "./../../utils/commonComponent/fetched";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import ListView from "../../utils/commonComponent/Custom/listView";
import {
  Autocomplete,
  Button,
  Checkbox,
  createFilterOptions,
  Grid,
  TextField,
} from "@mui/material";
import { getPermissions } from "../rbac/hasAccess";
import NABLHeader from "../image/Nabl_Header.png";
import NONABLHeader from "../image/NON_NABL_header.png";
import Footer from "../image/footer.png";
import LoaderModal from "../../utils/loader.js/loader";
import {
  branchOptions,
  departmentOptions,
} from "../employeeMaster/employeeConstants";
import moment from "moment";

const headers = [
  "id",
  "employeeName",
  "employeesCode",
  "leaveType",
  "fromDate",
  "toDate",
  "days",
  "approveManagerStatus",
  "approveLevel1Status",
  "approveLevel2Status",
  "finalLeaveStatus",
];

let config = {
  margin: 15,
  borderMagin: 7,
  headerImgHeight: 70,
  headerTableHeight: 25,
  headerTitleHeight: 15,
  footerImgHeight: 70,
  footerTableHeight: 50,
  fontSize: 9,
  cusotmerHeight: 50,
  bordergap: 5,
  currentY: 0,
  footerTotalHeight: 70 + 50,
};

const statusMap = {
  0: "Pending",
  1: "Pending",
  2: "Approved",
  3: "Rejected",
};

const filter = createFilterOptions();
const LeaveReport = (props) => {
  const navigate = useNavigate();
  const permissions = getPermissions(props.moduleId);
  const handleDelete = (row) => submitSiteDelete("leaveManagement", row.id);

  const [leaveManagementList, setLeaveManagementList] = useState([]);
  const [employeesData, setEmployeesData] = useState([]);
  const [inputStates, setInputStates] = React.useState({});
  const [searched, setSearched] = React.useState(false);
  const [letterHead, setLetterHead] = React.useState(true);
  const [loading, setLoading] = useState(false);
  const _employeeId = Number(localStorage.getItem("employeeId"));
  const _userType = Number(localStorage.getItem("type"));

  const updateInputObject = (key, value) => {
    setInputStates((prevInputStates) => ({
      ...prevInputStates,
      [key]: value,
    }));
    setSearched(false);
  };

  const getQuery = () => {
    const { employeeIds, leaveType, approveStatus, fromDate, toDate } =
      inputStates || {};
    const conditions = ["lm.status = 1"];

    // 🔹 Simple filters
    if (employeeIds?.length) {
      conditions.push(`lm.employeeId IN (${employeeIds.join(",")})`);
    }

    if (leaveType) conditions.push(`lm.leaveType = '${leaveType}'`);

    // 🔹 Approve status filter
    const approveStatusMap = {
      3: `(lm.approveManagerStatus = 3 OR lm.approveLevel1 = 3 OR lm.approveLevel2 = 3)`, // Rejected
      2: `lm.approveLevel2 = 2`, // Approved
      1: `(lm.approveManagerStatus NOT IN (2,3) 
       AND lm.approveLevel1 NOT IN (2,3) 
       AND lm.approveLevel2 NOT IN (2,3))`, // Pending
    };

    if (approveStatus && approveStatusMap[approveStatus]) {
      conditions.push(approveStatusMap[approveStatus]);
    }

    // 🔹 Date helper
    const getISODate = (date, isEnd = false) => {
      if (!date) return null;
      const d = new Date(date);
      return new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        isEnd ? 23 : 0,
        isEnd ? 59 : 0,
        isEnd ? 59 : 0
      ).toISOString();
    };

    const fromISO = getISODate(fromDate);
    const toISO = getISODate(toDate, true);

    // 🔹 Date conditions
    if (fromISO && toISO) {
      conditions.push(`lm.fromDate BETWEEN '${fromISO}' AND '${toISO}'`);
    } else {
      if (fromISO) conditions.push(`lm.fromDate >= '${fromISO}'`);
      if (toISO) conditions.push(`lm.toDate <= '${toISO}'`);
    }

    const whereClause = `WHERE ${conditions.join(" AND ")}`;

    return `
    SELECT
      lm.id, lm.documentNo, lm.applyLeaveDate, lm.leaveType, lm.leaveBalance,
      lm.fromDate, lm.toDate, lm.fromLeaveValue, lm.toLeaveValue, lm.remark,
      lm.docUrl, lm.employeeId, lm.approveManagerStatus, lm.reasonStatus,
      lm.rejectRemark, lm.approveLevel1 as approveLevel1Status, lm.approveLevel2 as approveLevel2Status,
      e.employeesCode AS employeesCode, e.name AS employeeName,
      eod.appprovalManagerId,
      CONCAT(em1.name,' (',em1.employeesCode,')') AS approvalManagerEmployee,
      eod.approvalLevel1Id,
      CONCAT(em2.name,' (',em2.employeesCode,')') AS approvalLevel1Employee,
      eod.approvalLevel2Id,
      CONCAT(em3.name,' (',em3.employeesCode,')') AS approvalLevel2Employee
    FROM leaveManagement lm
    LEFT JOIN employees e ON lm.employeeId = e.id
    LEFT JOIN employeeOtherData eod ON lm.employeeId = eod.employeeId
    LEFT JOIN employees em1 ON eod.appprovalManagerId = em1.id
    LEFT JOIN employees em2 ON eod.approvalLevel1Id = em2.id
    LEFT JOIN employees em3 ON eod.approvalLevel2Id = em3.id
    ${whereClause}
    ORDER BY lm.id DESC;
  `;
  };

  const getDaysBetween = (fromDate, toDate, MS_IN_DAY) => {
    if (!fromDate || !toDate) return 0;
    const start = new Date(fromDate);
    const end = new Date(toDate);
    if (isNaN(start) || isNaN(end)) return 0;
    return Math.abs(Math.floor((end - start) / MS_IN_DAY)) + 1;
  };

  const fetchData = async () => {
    try {
      const query = getQuery();
      const leaveManagement = await fetchQuery(query);

      const MS_IN_DAY = 1000 * 60 * 60 * 24;

      const updatedLeaveManagement = leaveManagement.map((item) => {
        const statuses = [
          item.approveManagerStatus,
          item.approveLevel1Status,
          item.approveLevel2Status,
        ].map(Number);

        // const leaveStatus = statuses.includes(3)
        //   ? statusMap[3]
        //   : statuses.reverse().includes(2)
        //   ? statusMap[2]
        //   : statusMap[0];

        const leaveStatus = statuses.includes(3)
          ? statusMap[3]
          : statusMap[item.approveLevel2Status] || item.approveLevel2Status;

        return {
          ...item,
          days: getDaysBetween(item.fromDate, item.toDate, MS_IN_DAY),
          approveManagerStatus:
            statusMap[item.approveManagerStatus] || item.approveManagerStatus,
          approveLevel1Status: statusMap[item.approveLevel1Status] || item.approveLevel1Status,
          approveLevel2Status: statusMap[item.approveLevel2Status] || item.approveLevel2Status,
          finalLeaveStatus:leaveStatus,
        };
      });

      setLeaveManagementList(updatedLeaveManagement);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  const fetchEmployeesData = async () => {
    try {
      let whereConditions = "";

      // 👤 User-type restriction
      if (_userType !== 1 && _userType !== 2 && _userType !== 8) {
        whereConditions = ` WHERE e.id = ${_employeeId}`;
      }

      // 🏢 Department condition
      if (inputStates?.department) {
        whereConditions += whereConditions
          ? ` AND eod.department = '${inputStates.department}'`
          : ` WHERE eod.department = '${inputStates.department}'`;
      }

      // 🏬 Branch condition
      if (inputStates?.branch) {
        whereConditions += whereConditions
          ? ` AND eod.branchId = '${inputStates.branch}'`
          : ` WHERE eod.branchId = '${inputStates.branch}'`;
      }

      const Employees = await fetchQuery(`
      SELECT 
        e.id, 
        e.employeesCode, 
        e.name
      FROM employees e
      LEFT JOIN employeeOtherData eod 
        ON eod.employeeId = e.id
      ${whereConditions}
    `);

      setEmployeesData(Employees);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  function addHeaderFooter(doc) {
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const headers = {
      1: NABLHeader,
      2: NONABLHeader,
    };
    const headerImage = NABLHeader;
    doc.addImage(headerImage, "PNG", 0, 0, pageWidth, config?.headerImgHeight);
    doc.addImage(
      Footer,
      "PNG",
      0,
      pageHeight - config?.footerImgHeight,
      pageWidth,
      config?.footerImgHeight
    );
  }

 const generateLeaveReport = ({
  leaveManagementList,
  headers,
  letterHead,
}) => {
  try {
    requestAnimationFrame(() => {
      const doc = new jsPDF({
        orientation: "p",
        unit: "pt",
        format: "a4",
        compress: true,
      });

      // 🔹 Format headers
      const formattedHeaders = headers.map((h) =>
        h === "id"
          ? "Sr. No"
          : h
              .replace(/([A-Z])/g, " $1")
              .replace(/^./, (s) => s.toUpperCase())
      );

      // 🔹 Prepare rows with formatted dates
      const tableRows = leaveManagementList.map((row, index) =>
        headers.map((key) => {
          // Sr No column
          if (key === "id") return index + 1;

          // ✅ Format fromDate & toDate
          if (key === "fromDate" || key === "toDate") {
            return row[key]
              ? moment(row[key])
                  .local() // convert UTC to local time
                  .format("DD/MM/YYYY")
              : "";
          }

          return row[key] ?? "";
        })
      );

      // 🔹 Draw table
      autoTable(doc, {
        head: [formattedHeaders],
        body: tableRows,
        startY:
          config.headerImgHeight +
          config.headerTableHeight +
          config.headerTitleHeight +
          config.borderMagin,
        styles: {
          fontSize: config.fontSize,
          cellPadding: 4,
          fillColor: null,
          lineWidth: 0.5,
          lineColor: 0,
        },
        headStyles: {
          fillColor: null,
          textColor: 0,
          halign: "center",
        },
        bodyStyles: {
          fillColor: null,
          halign: "center",
        },
        alternateRowStyles: {
          fillColor: null,
        },
        margin: { left: config.margin, right: config.margin },
        didDrawPage: () => {
          if (letterHead) addHeaderFooter(doc);
        },
      });

      doc.save("Leave-Report.pdf");
      setLoading(false);
    });
  } catch (error) {
    console.error("Error generating PDF:", error);
    setLoading(false);
  }
};

  const handleSearch = () => {
  if (
  ![1, 2, 8].includes(_userType) &&
  Array.isArray(inputStates?.employeeIds) &&
  inputStates?.employeeIds?.length === 0
) {
  toast.error("At least select one employee");
  return;
}


    fetchData();
    setSearched(true);
  };

  const clearSearch = () => {
    setSearched(false);
   setInputStates((prev) => ({
  employeeIds: prev.employeeIds,
}));

    setLeaveManagementList([]);
  };

  useEffect(() => {
    fetchEmployeesData();
  }, [inputStates?.department, inputStates?.branch]);

  useEffect(() => {
    if (
      _userType !== 1 &&
      _userType !== 2 &&
      _userType !== 8 &&
      employeesData.length > 0
    ) {
      updateInputObject("employeeIds", [employeesData[0].id]);
    }
  }, [_userType, employeesData]);

  return (
    <>
      <br />
      <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* ================= ONLY FOR USER TYPE 1,2,8 ================= */}
        {[1, 2, 8].includes(_userType) && (
          <>
            {/* Department */}
            <Autocomplete
              size="small"
              fullWidth
              options={departmentOptions}
              value={
                departmentOptions.find(
                  (opt) => opt.name === inputStates.department
                ) || null
              }
              getOptionLabel={(option) => option.name}
              onChange={(e, val) =>
                updateInputObject("department", val ? val.name : "")
              }
              renderInput={(params) => (
                <TextField {...params} label="Department" />
              )}
            />

            {/* Branch */}
            <Autocomplete
              size="small"
              fullWidth
              options={branchOptions}
              value={
                branchOptions.find((opt) => opt.name === inputStates.branch) ||
                null
              }
              getOptionLabel={(option) => option.name}
              onChange={(e, val) =>
                updateInputObject("branch", val ? val.name : "")
              }
              renderInput={(params) => <TextField {...params} label="Branch" />}
            />

            {/* Employee */}
            <Autocomplete
              multiple
              limitTags={1}
              size="small"
              disableCloseOnSelect
              fullWidth
              options={[{ id: "ALL", name: "Select All" }, ...employeesData]}
              isOptionEqualToValue={(opt, val) => opt.id === val.id}
              getOptionLabel={(option) =>
                option.id === "ALL"
                  ? "Select All"
                  : `${
                      option.employeesCode ? option.employeesCode + " - " : ""
                    }${option.name}`
              }
              value={employeesData.filter((emp) =>
                inputStates.employeeIds?.includes(emp.id)
              )}
              onChange={(e, selected) => {
                const all = selected.some((opt) => opt.id === "ALL");
                updateInputObject(
                  "employeeIds",
                  all
                    ? employeesData.map((e) => e.id)
                    : selected.map((e) => e.id)
                );
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    sx={{ mr: 1 }}
                    checked={
                      option.id === "ALL"
                        ? inputStates.employeeIds?.length ===
                          employeesData.length
                        : selected
                    }
                  />
                  {option.id === "ALL"
                    ? "Select All"
                    : `${
                        option.employeesCode ? option.employeesCode + " - " : ""
                      }${option.name}`}
                </li>
              )}
              renderInput={(params) => (
                <TextField {...params} label="Employee" />
              )}
            />
          </>
        )}

        {/* ================= ALWAYS VISIBLE ================= */}

        {/* Leave Type */}
        <Autocomplete
          size="small"
          fullWidth
          options={[
            { id: 1, name: "Sick Leave" },
            { id: 2, name: "Casual Leave" },
            { id: 3, name: "Privileged Leave" },
            { id: 4, name: "Maternity Leave" },
            { id: 5, name: "Paternity Leave" },
            { id: 7, name: "Menstrual Leave" },
          ]}
          value={
            inputStates.leaveType
              ? { id: null, name: inputStates.leaveType }
              : null
          }
          onChange={(e, val) =>
            updateInputObject("leaveType", val ? val.name : "")
          }
          getOptionLabel={(opt) => opt?.name || ""}
          renderInput={(params) => <TextField {...params} label="Leave Type" />}
        />

        {/* From Date */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="From Date"
            value={inputStates.fromDate || null}
            onChange={(val) => updateInputObject("fromDate", val)}
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </LocalizationProvider>

        {/* To Date */}
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            label="To Date"
            value={inputStates.toDate || null}
            onChange={(val) => updateInputObject("toDate", val)}
            slotProps={{ textField: { size: "small", fullWidth: true } }}
          />
        </LocalizationProvider>

        {/* Approve Status */}
        <Autocomplete
          size="small"
          fullWidth
          options={[
            { id: 1, name: "Pending" },
            { id: 2, name: "Approved" },
            { id: 3, name: "Rejected" },
          ]}
          value={
            inputStates.approveStatus
              ? {
                  id: inputStates.approveStatus,
                  name: ["Pending", "Approved", "Rejected"][
                    inputStates.approveStatus - 1
                  ],
                }
              : null
          }
          onChange={(e, val) =>
            updateInputObject("approveStatus", val ? val.id : "")
          }
          getOptionLabel={(opt) => opt?.name || ""}
          renderInput={(params) => (
            <TextField {...params} label="Approve Status" />
          )}
        />

        {/* Search */}
        <div className="flex items-end">
          <SearchToggleButton
            searched={searched}
            onSearch={handleSearch}
            onClear={clearSearch}
          />
        </div>
      </div>

      {(permissions.pdfDownload || permissions.allAccess) && (
        <>
          <br />
          <br />
          <div
            className="mb-5"
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "16px",
              alignItems: "flex-start",
            }}
          >
            <div
              style={{
                flex: "1 1 250px",
                maxWidth: "300px",
                display: "flex",
                alignItems: "center",
              }}
            >
              <AddButton
                label="Download PDF"
                id="quotation_view_generatepdf"
                onClick={() => {
                  setLoading(true); // show loader immediately

                  requestAnimationFrame(() => {
                    generateLeaveReport({
                      leaveManagementList,
                      headers,
                      letterHead,
                    });
                  });
                }}
              />
            </div>
          </div>
        </>
      )}
      <br />

      <ListView
        headers={headers}
        data={leaveManagementList}
        actions={
          {
            //   edit: handleEdit,
            //   delete: handleDelete,
          }
        }
        // showCheckbox={true} //enable checkbox
        // deleteTableName={"leaveManagement"}
        moduleId={props.moduleId}
        totalRows={leaveManagementList?.length}
        rowsPerPageOptions={[-1]}
      />

      <LoaderModal loading={loading} />
    </>
  );
};

export default LeaveReport;
